import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveContact,
  assignContactToUser,
  bulkUploadContacts,
  deleteContact,
  getAllContacts,
  getContactByID,
  insertContact,
  insertContactFromOtherPlace,
  updateContact,
} from "./services/contact.services";
import { IContact, IContactInitialState } from "./contactModel";

const initialState: IContactInitialState = {
  loading: false,
  formLoading: false,
  bulkUploadLoading: false,
  error: "",
  activeTabIndex: 0,
  VisaCountryDeleteIndex: -1,
  ContactList: [],
  ContactID: null,
  ContactDetails: {
    Initial: "",
    FirstName: "",
    LastName: "",
    CountryCode: "",
    MobileNo: "",
    AlternateMobileNo: "",
    EmailID: "",
    AlternateEmailID: "",
    LeadSourceID: null,
    CountryID: null,
    StateID: null,
    CityID: null,
    Pincode: "",
    Address: "",
    DateofBirth: "",
    MaritalStatus: "",
    MarriageAnniversary: "",
    NoofKids: null,
    FoodPreferenceID: null,
    PassportNumber: "",
    PassportExpiry: "",
    CustomerCategory: "",
    CompanyName: "",
    GSTNumber: "",
    Pancard: "",
    Tags: "",
    Remarks: "",
    ContactVisa: [],
  },
  ContactFilterDetails: {
    filterName: "",
    filterMobileNo: "",
    filterEmailID: "",
    filterFromDate: "",
    filterToDate: "",
    filterUnassignedContacts: false,
  },
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    clearContactDetails: (state) => {
      state.ContactDetails = initialState.ContactDetails;
    },
    setContactID: (state, action) => {
      state.ContactID = action.payload;
    },
    clearContactID: (state) => {
      state.ContactID = initialState.ContactID;
    },
    setactiveTabIndex: (state, action) => {
      state.activeTabIndex = action.payload;
    },
    setContactFilterDetails: (state, action) => {
      state.ContactFilterDetails = action.payload;
    },
    clearContactFilterDetails: (state) => {
      state.ContactFilterDetails = initialState.ContactFilterDetails;
    },
    setVisaCountryDeleteIndex: (state, action) => {
      state.VisaCountryDeleteIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllContacts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllContacts.fulfilled,
      (state, action: PayloadAction<IContact[]>) => {
        state.loading = false;
        state.ContactList = action.payload || [];
      }
    );
    builder.addCase(getAllContacts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContactList = [];
    });

    builder.addCase(updateContact.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateContact.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(insertContact.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertContact.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertContact.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(insertContactFromOtherPlace.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertContactFromOtherPlace.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertContactFromOtherPlace.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteContact.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteContact.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getContactByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getContactByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ContactDetails = action.payload;
    });
    builder.addCase(getContactByID.rejected, (state, action) => {
      state.loading = false;
      state.ContactDetails = initialState.ContactDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(assignContactToUser.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(assignContactToUser.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(assignContactToUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(ActiveInactiveContact.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveContact.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(bulkUploadContacts.pending, (state) => {
      state.bulkUploadLoading = true;
      state.error = "";
    });
    builder.addCase(bulkUploadContacts.fulfilled, (state) => {
      state.bulkUploadLoading = false;
    });
    builder.addCase(bulkUploadContacts.rejected, (state, action) => {
      state.bulkUploadLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearContactDetails,
  setactiveTabIndex,
  clearContactID,
  setContactID,
  setVisaCountryDeleteIndex,
  setContactFilterDetails,
  clearContactFilterDetails,
} = contactSlice.actions;
export default contactSlice.reducer;
